// @flow
import React from 'react';
import './MultiUnitTitle.less';

type Props = {
    headline: string
};
export default function MultiUnitTitle(props: Props) {
    const {headline} = props;
    return <h3 className="MultiUnitDropdown__title"> {headline}</h3>;
}
